// extracted by mini-css-extract-plugin
export default {"homeLink":"homeLinkCWgYY","restrictedChannel":"restrictedChannellpqjR"};